import React from 'react';
import './Home.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons'


const Home = () => {


    return (
        <section id="home">
        <div className="home_container">
            
            <div className="glass_container">
                <h1>Hello, I'm <span>Phanindra Reddy.</span></h1>
                <h1>I'm a front-end web developer.</h1>

                <div className="home_btns">
                    <a href="https://phanindra-reddy.github.io/js-books/Phanindra's%20Resume%20(1).pdf" target="_blank" className="resume_btn" rel="noreferrer">
                        Resume
                        <span>
                            <FontAwesomeIcon icon={faFileAlt} style={{margin:'0px 10px'}}/>
                        </span>
                    </a>
                    
                    <a href="#about" className="work_btn" rel="noreferrer">
                        View Work
                        <span>
                            <FontAwesomeIcon icon={faArrowRight} className="right_arrow" style={{margin:'0px 10px'}}/>
                        </span>
                    </a>

                </div>
            </div>

        </div>

        </section>
    )
}

export default Home;
